import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SoapExecutePayload, SoapExecuteResult, WsdlOperationDto } from './roller-api-operations';

export interface WsdlResponse {
  success: boolean;
  endpoint?: string;
  functions?: string[];
  types?: string[];
  operations?: WsdlOperationDto[];
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class RollerApiService {
  private readonly baseUrl = `${environment.prismaApiUrl}/api/common/soap`;

  constructor(private http: HttpClient) {}

  getWsdl(): Observable<WsdlResponse> {
    return this.http.get<WsdlResponse>(`${this.baseUrl}/get-wsdl`);
  }

  execute(payload: SoapExecutePayload): Observable<SoapExecuteResult> {
    return this.http.post<SoapExecuteResult>(`${this.baseUrl}/execute`, payload);
  }
}
